const drill_en = require('./drill.json')
export default drill_en